import { Subject } from "rxjs";
import { CrossWindowMessage } from './definitions';

export const enum CrossWindowEvents {
    RC_FORWARD_DATA = "rcmessage",
    RC_SOCKET_EVENT = "rcSocketEvent",
    PR_POPOUT_READY = "rcPopoutReady",
    RC_POPIN = "rcPopin",
    RC_BUFFER = "rcbuffer",
    NEW_VIDEO_ATTACHED = "newVideoAttached",
    ATTACH_SCREENSHOT = "attachScreenshot",
    WORK_PANEL_ATTACH_SCREENSHOT = "workPanelAttachScreenshot",
    WORK_PANEL_POPOUT_READY = "workPanelPopoutReady",
    WORK_PANEL_POPIN = "workPanelPopin",
};

export const enum WebSocketEventTypes {
    RC_SEND = "rcSend",
    SOCKET_ERROR = "error",
    SOCKET_CONNECT = "connect",
    SOCKET_CLOSE = "close"
};

export class CrossWindowProxy {
    static rcmessage = 1;
    protected _window: Window;
    protected subjects = new Map<number, Subject<any>>();

    constructor(wnd: Window) { this._window = wnd; }

    /** sending messages between the embedded RC panel and the popout window. When sending Transferable data
     * using the faster mode. Non-transferable is sent in a message
     */
    public static postMessage = (wnd: Window, messageType: CrossWindowEvents | WebSocketEventTypes, transferableData?: Transferable, simpleData?: any): void => {
        const msg = new CrossWindowMessage(messageType, transferableData || simpleData);
        // console.debug(`Sending message in postMessage ${messageType} from ${window.location.href}`);
        // Post data to target window, using Transferable since it is faster. IE is not supported
        if (transferableData === undefined) {
            wnd.postMessage(msg, window.location.origin);
        } else {
            // console.debug(`postMessage type ${typeof transferableData}`, transferableData)
            wnd.postMessage(msg, window.location.origin, [transferableData]);
        }
    };

    public static onWindowMessage = (wnd: Window, callback: (msg: CrossWindowMessage) => void) => {
        const handleMessage = (event: MessageEvent<CrossWindowMessage>) => {
            // Restrict messages to those originating from the same origin
            if (event.origin !== window.location.origin) {
                return;
            }
            callback(event.data);
        };
        wnd.addEventListener("message", handleMessage, false);

        // Return a function that can be used to unbind the listener
        return () => wnd.removeEventListener("message", handleMessage);
    }
}

/** proxy for the socketless client, used to notify that client window
 * about the socket events, or to receive requests via observables
 */
export class CrossWindowClientProxy extends CrossWindowProxy {
    constructor(clientWindow: Window) {
        super(clientWindow);
    }
    /** notify the socketless client window about main socket events */
    public notify = (type: string) => CrossWindowProxy.postMessage(this._window, CrossWindowEvents.RC_SOCKET_EVENT, undefined, { type: type });
    /** forward the socket message to the socketless client in another window */
    public forwardMessage = (data: Uint8Array) => CrossWindowProxy.postMessage(this._window, CrossWindowEvents.RC_FORWARD_DATA, data.buffer);

    // get onPopoutReady(): Subject<any> { return null; };
    // get onWorkPanelPopoutReady(): Subject<any> { return null; }
    // get onPopin(): Subject<any> { return null; }
    // get onWorkPanelPopin(): Subject<any> { return null; }
    // get onAttachmentScreenshot(): Subject<any> { return null; }
    // get onWorkPanelAttachmentScreenshot(): Subject<any> { return null; }
}

/** proxy for the socket running in a different browser window, listening for events and messages 
 * received from the remote socket and acting like a socket replacement */
export class CrossWindowSocketProxy extends CrossWindowProxy {
    constructor(wnd: Window) {
        super(wnd);
    }
    
    notify = (event: WebSocketEventTypes, data: Uint8Array) => {
        console.log("NOTIFY sending", event, data);
        CrossWindowProxy.postMessage(this._window, event, data.buffer);
    };

    get window(): Window {
        return this._window;
    }

    /** Start listening for events and messages received on the remote socket.
     * Returns an IWindowMessage observable
     */
    onMessageForwarded(callback: (msg: CrossWindowMessage) => void): () => void {
        return CrossWindowProxy.onWindowMessage(this._window, callback);
    }
}
